import React from 'react'
import styled from '@emotion/styled'

import * as styles from '../styles'

const StyledInput = styled.input((props) => styles.input(props))

const defaultRenderer = ({ onInternalKeyDown, onKeyDown, ...props }) => {
  const handleKeyDown = (event) => (onInternalKeyDown || onKeyDown)(event)

  return (
    <StyledInput onKeyDown={handleKeyDown} {...props} />
  )
}

export default defaultRenderer
